var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMeasure = function SvgMeasure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.229 9.747l-1.886 1.886L4.7 13.99l8.957-8.957L11.3 2.677 9.885 4.09l.944.942-.944.943-.942-.943-1.414 1.415 1.414 1.413L8 8.805 6.586 7.391 5.171 8.805l.944.943-.944.943-.942-.943zm7.542-8.485l3.3 3.3a.667.667 0 010 .943l-9.9 9.9a.667.667 0 01-.942 0l-3.3-3.3a.667.667 0 010-.943l9.9-9.9a.667.667 0 01.942 0z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "measure_svg__clip0_261_10532"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgMeasure;